// extracted by mini-css-extract-plugin
export default {"sign_up":"sign-up_sign_up__k+3a4","primary_btn":"sign-up_primary_btn__zi8tx"};